<template>
    <PullContainer
        ref="pullContainerRef"
        :pullDownLoading="true"
        :pullDownLabel="true"
        @pullDownLoadingSuccess="pullDownLoadingSuccess"
    >
        <template #container>
            <div class="public_container department_personnel_wrap" v-loading="loading">
                <div class="returnNavBar">
                    <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true" :isCustomReturnEvent="true" @returnEvent="handleClickReturnRouter"> </ReturnNavBar>
                    <div class="returnNavBarRight">
                        <van-popover
                            v-model="showOperatorPopover"
                            placement="bottom-end"
                            trigger="click"
                            ref="top_operator_popover"
                            class="top_operator_popover"
                        >
                            <div class="top_operator_list">
                                <li
                                    v-for="item in isShowDepartment ? operatorList : personnelOperatorList"
                                    :key="item.type"
                                    @click="handleClickOperate(item)"
                                >
                                    <i :class="['iconfont', item.icon]"></i><span>{{ item.title }}</span>
                                </li>
                            </div>
                            <template #reference>
                                <i class="iconfont icon-a-tianjiamiaobian"></i>
                            </template>
                        </van-popover>
                    </div>
                </div>
                <div class="top_search">
                    <van-search
                        v-model="searchForm.keyword"
                        placeholder="请输入查询内容"
                        @search="onSearch"
                        @clear="onSearch"
                    >
                        <template #right-icon>
                            <i class="iconfont icon-shaixuan" @click="handleClickAdvancedFilter"></i>
                        </template>
                    </van-search>
                </div>
                <div class="mobile_container" v-if="isShowDepartment">
                    <p class="tree_content_title">
                        <span @click="handleClickDetail({}, 'company')">{{ company_name }}（{{ total_users }}）</span>
                        <i
                            class="iconfont icon-gengduo"
                            @click="handleClickRadioShow({ id: 0, department_name: company_name })"
                        ></i>
                    </p>
                    <el-tree
                        :data="departmentList"
                        :expand-on-click-node="false"
                        :props="{ children: 'children', label: 'relate_name' }"
                        check-on-click-node
                        default-expand-all
                        node-key="relate_id"
                        @node-click="handleClickDepNode"
                    >
                        <div slot-scope="{ node, data }" class="custom_tree_node">
                            <div class="custom_tree_text" @click="handleClickDetail(data)">
                                <span class="ellipsis">{{ data.department_name }}</span>
                                <span>（{{ data.user_count }}）</span>
                            </div>
                            <div class="custom_tree_icon" @click="handleClickRadioShow(data)">
                                <i class="iconfont icon-gengduo"></i>
                            </div>
                        </div>
                    </el-tree>
                </div>
                <div class="mobile_container" v-else>
                    <ul v-infinite-scroll="onLoadList">
                        <li
                            v-for="(item, index) in tableData"
                            :key="index"
                            @click.stop="handleClickPersonnelDetail(item)"
                        >
                            <div class="img_box">
                                <img :src="item.avatar ? item.avatar : defaultImg" alt="" />
                            </div>
                            <div class="list_item_middle">
                                <p>
                                    <span class="ellipsis">{{ item.name && item.name.value }}</span>
                                    <template>
                                        <span
                                            class="tag_status tag_status_danger"
                                            v-if="item.quit_info && item.quit_info.quit_status == 0"
                                            >待离职</span
                                        >
                                        <span class="tag_status tag_status_warning" v-if="item.entry_status == 1"
                                            >待入职</span
                                        >
                                        <span
                                            class="tag_status tag_status_success"
                                            v-if="item.status == 'pendingConfirm'"
                                            >待确定</span
                                        >
                                        <span
                                            class="tag_status tag_status_warning2"
                                            v-if="item.is_active == 0 && item.entry_status == 0"
                                            >未注册</span
                                        >
                                    </template>
                                </p>
                                <p>
                                    <template v-if="item.department_id">
                                        {{
                                            item.department_id.text && item.department_id.text.length
                                                ? item.department_id.text
                                                      .map((department) => department.department_name)
                                                      .join("、")
                                                : "--"
                                        }}
                                    </template>
                                    <template v-else>--</template>
                                </p>
                            </div>
                            <div class="list_item_right" v-if="isCheck" @dblclick.stop.prevent @click.stop.prevent>
                                <van-checkbox
                                    v-model="item.checked"
                                    shape="square"
                                    @change="handleClickChangeSelect(item)"
                                ></van-checkbox>
                            </div>
                        </li>
                    </ul>
                </div>
                <van-overlay
                    :custom-style="{ background: 'rgba(0, 0, 0, 0.3)', zIndex: 99999 }"
                    v-if="showRadioPicker"
                    :show="showRadioPicker"
                >
                    <div class="radio_option_wrap">
                        <ul class="radio_option_list">
                            <li
                                v-for="item in itemOperatorList"
                                class="radio_option_item"
                                @click="handleClickRadioOption(item)"
                                v-text="item.label"
                            ></li>
                        </ul>
                        <div class="cancel_btn" @click="showRadioPicker = false">取消</div>
                    </div>
                </van-overlay>
                <van-dialog
                    v-model="deleteVisible"
                    title=""
                    :show-cancel-button="showCancanelBtn"
                    confirmButtonColor="#2990FF"
                    @confirm="handleDeleteConfirm"
                    class="my_dialog my_delete_dialog"
                >
                    <p class="title">
                        删除<span :class="{ text_red: deleteFail }">{{ deleteFail ? "失败" : "部门" }}</span>
                    </p>
                    <p>{{ deleteContent }}</p>
                </van-dialog>
                <FooterTabbar :tabBarList="tabBarList" :tabBarActive="tabBarActive"></FooterTabbar>
                <ListAdvancedFiltering
                    v-if="searchPopupShow"
                    ref="listAdvancedFiltering"
                    :field_form="'users'"
                    :system_fields="systemFilterFields"
                    @sendFilterData="getFilterData"
                />
                <div class="batch_select_icon" v-if="isCheck && !isShowDepartment" @click="handleClickShowUser">
                    <i class="iconfont icon-renyuan"></i
                    ><span v-if="selectedList.length">{{ selectedList.length }}</span>
                </div>
                <SelectUserList
                    :selectUserListVisible.sync="selectUserListVisible"
                    :selectUserListData.sync="selectedList"
                    @changeItemSelete="changeItemSelete"
                />
                <BatchOperateBar
                    :operateBarList="operateBarList"
                    @handleClickOperateType="handleClickOperateType"
                    v-if="isCheck && !isShowDepartment"
                />
                <ListAdvancedFiltering
                    v-if="searchPopupShow"
                    ref="listAdvancedFiltering"
                    :field_form="'users'"
                    :system_fields="systemFilterFields"
                    @sendFilterData="getFilterData"
                />
            </div>
        </template>
    </PullContainer>
</template>

<script>
import { mapState } from "vuex";
import { GetCompanyDepartmentList, DepartmentDel, getUserListPage , CheckUserAuthDepartment} from "@/api";
import { pagination } from "@/mixins";
import { Dialog } from "vant";
import { EventBus } from '@/utils/eventBus';
import PullContainer from "@/components/mComponents/PullContainer.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import FooterTabbar from "@/components/mComponents/FooterTabbar.vue";
import ListAdvancedFiltering from "@/components/mComponents/ListAdvancedFiltering";
import BatchOperateBar from "../component/batch_operate_bar.vue";
import SelectUserList from "../component/select_user_list.vue";
export default {
    name: "DepartmentPersonnel",
    components: { PullContainer, ReturnNavBar, FooterTabbar, ListAdvancedFiltering, BatchOperateBar, SelectUserList },
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            loading: false,
            showOperatorPopover: false,
            operatorList: [
                { icon: "icon-a-shenling1", title: "新增员工", type: "add" },
                { icon: "icon-a-shenling1", title: "邀请加入", type: "invit" },
            ], // 部门
            personnelOperatorList: [
                { icon: "icon-a-shenling1", title: "新增员工", type: "add" },
                { icon: "icon-a-shenling1", title: "邀请加入", type: "invit" },
                { icon: "icon-fenpei", title: "批量操作", type: "batch" },
            ], // 人员
            searchForm: {
                keyword: "",
            },
            showRadioPicker: false,
            allItemOperatorList: [
                { type: "addChild", label: "添加子部门" },
                { type: "edit", label: "编辑" },
                { type: "delete", label: "删除" },
            ],
            showCancanelBtn: true,
            deleteVisible: false,
            deleteFail: false, // 删除失败
            deleteContent: "删除部门后不可恢复！该部门所关联的业务将全部清空，请谨慎操作！",
            itemOperatorList: [],
            currentOperateData: {}, // 当前操作的节点
            departmentList: [],
            tabBarList: [
                {
                    icon: "icon-shouye",
                    activeIcon: "icon-shouyexuanzhong",
                    routerName: "MPersonnelIndex",
                    title: "首页",
                },
                {
                    icon: "icon-tianjiachengyuan",
                    activeIcon: "icon-tianjiachengyuan-xuanzhong",
                    routerName: "DepartmentPersonnel",
                    title: "人员组织",
                },
                {
                    icon: "icon-lizhi",
                    activeIcon: "icon-lizhi-xuanzhong",
                    routerName: "DimissionManage",
                    title: "离职管理",
                },
            ],
            tabBarActive: 1,
            total_users: 0,
            company_name: "",

            tableData: [],
            pullLoading: false,
            finishedList: false,
            listLoading: false,
            isCheckAll: false, // 是否全选
            isCheck: false, // 是否批量选择
            selectedList: [], // 复选框选中数据
            operateBarList: [
                { icon: "icon-fenpei", title: "变更部门", type: "changeDepartment" },
                { icon: "icon-hebingkehu", title: "邀请完善信息", type: "invit" },
            ],
            selectUserListVisible: false, // 选择的用户数据
            systemFilterFields: [
                {
                    field_type: "checkbox",
                    field_key: "u.gender",
                    is_system: 1,
                    field_name: "性别",
                    system_type: "system",
                    options: [
                        {
                            label: "男",
                            value: 1,
                        },
                        {
                            label: "女",
                            value: 2,
                        },
                    ],
                },
                {
                    field_type: "date",
                    field_key: "u.joined_date",
                    is_system: 1,
                    field_name: "入职日期",
                    system_type: "system",
                    date_type: "date",
                },
                {
                    field_type: "checkbox_user_tag",
                    field_key: "u.user_tag_id",
                    is_system: 1,
                    field_name: "人员标签",
                    system_type: "system",
                    options: [],
                },
                {
                    field_type: "contact",
                    field_key: "u.superior_id",
                    is_system: 1,
                    field_name: "直属上级",
                    system_type: "system",
                },
                {
                    field_type: "department",
                    field_key: "u.department_id",
                    is_system: 0,
                    field_name: "部门",
                    system_type: "system",
                },
            ], // 高级筛选字段
            custom_filter: {}, // 高级筛选确认条件
        };
    },
    mixins: [pagination],
    computed: {
        ...mapState(["searchPopupShow"]),
        isShowDepartment() {
            let custom_data = this.custom_filter.custom_field
                ? [...this.custom_filter.custom_field, ...this.custom_filter.system_field]
                : [];
            const custom_filter_data = custom_data.filter((item) => item.field_value !== "");
            // 是否有筛选条件 有筛选条件展示人员信息，否则显示部门列表
            if (this.searchForm.keyword || custom_filter_data.length) {
                return false;
            }
            this.isCheck = false;
            return true;
        },
    },
    created() {
        EventBus.$on('personnelAddUpdated', this.getLocalStorageFunction);
        this.getLocalStorageFunction();
    },
    methods: {
        handleClickReturnRouter() {
            if(this.isCheck) {
                this.isCheck = false
            } else {
                if (this.$router.history.length <= 1) {
                    // 没有上一页，跳转到固定页面
                    this.$router.push({ name: 'mobileAllFunctions' });
                } else {
                    // 有上一页，后退
                    this.$router.go(-1);
                }
            }
        },
        pullDownLoadingSuccess(flag) {
            if (flag) {
                this.pullDownLoading = true;
                if (this.isShowDepartment) {
                    this.getDepartmentList();
                } else {
                    this.onPullRefreshList();
                }
            }
        },
        // 读取缓存
        getLocalStorageFunction() {
            let localStorageData = localStorage.getItem("mobilePersonnelIndexParams");
            if (localStorageData) {
                localStorageData = JSON.parse(localStorageData);
                this.searchForm.keyword = localStorageData.keyword;
                this.custom_filter = localStorageData.custom_filter;
            }
            this.$nextTick(() => {
                if (this.isShowDepartment) {
                    this.getDepartmentList();
                } else {
                    this.onPullRefreshList();
                }
            });
            localStorage.removeItem("mobilePersonnelIndexParams");
        },
        // 写入缓存
        setLocalStorageFunction() {
            const params = {
                keyword: this.searchForm.keyword,
                custom_filter: this.custom_filter,
            };
            localStorage.setItem("mobilePersonnelIndexParams", JSON.stringify(params));
        },
        // 右上角操作
        handleClickOperate({ type }) {
            this.showOperatorPopover = false;
            switch (type) {
                case "add":
                    this.$router.push({
                        name: "MPersonnelAdd",
                    });
                    break;
                case "invit":
                    // 邀请新员工加入
                    this.$router.push({
                        name: "MPersonnelInvite",
                        query: {
                            type: 2,
                        },
                    });
                    break;
                case "batch":
                    // 批量操作
                    this.isCheck = true;
                    break;
            }
        },
        // 节点选项弹框
        handleClickRadioShow(item) {
            this.showRadioPicker = true;
            this.currentOperateData = item;
            if (item.id) {
                // 子节点操作
                // 判断是否等级是否小于5，最多5级部门
                if (item.level < 5) {
                    this.itemOperatorList = JSON.parse(JSON.stringify(this.allItemOperatorList));
                } else {
                    this.itemOperatorList = this.allItemOperatorList.slice(1);
                }
            } else {
                // 最顶层数据操作
                this.itemOperatorList = this.allItemOperatorList.slice(0, 1);
            }
        },
        // 点击高级筛选
        handleClickAdvancedFilter() {
            this.$store.dispatch("searchPopupShow", true);
        },
        // 获取高级筛选数据
        getFilterData(data) {
            this.custom_filter = data;
            this.$store.dispatch("searchPopupShow", false);
            this.onPullRefreshList();
        },
        // 节点选项选择
        handleClickRadioOption({ type }) {
            this.showRadioPicker = false;
            switch (type) {
                case "addChild":
                    // 添加子部门
                    this.$router.push({
                        name: "MDepartmentAdd",
                        query: {
                            did: this.currentOperateData.id,
                            pName: this.currentOperateData.department_name,
                            pid: this.currentOperateData.pid,
                        },
                    });
                    break;
                case "edit":
                    // 编辑
                    this.$router.push({
                        name: "MDepartmentEdit",
                        query: {
                            did: this.currentOperateData.id,
                        },
                    });
                    break;
                case "delete":
                    // 删除
                    this.deleteVisible = true;
                    break;
            }
        },
        // 删除确认
        handleDeleteConfirm() {
            DepartmentDel({ id: this.currentOperateData.id }).then((res) => {
                if (res.code === 200) {
                    this.$toast(res.message);
                    this.currentOperateData = {};
                    this.getDepartmentList();
                } else {
                    this.$toast(res.message);
                }
            });
        },
        // 查看部门人员
        handleClickDetail(item, type) {
            this.$router.push({
                name: "MPersonnelList",
                query: {
                    id: item.id,
                    name: type ? this.company_name : item.department_name,
                },
            });
        },
        // 点击人员详情
        handleClickPersonnelDetail(row) {
            this.setLocalStorageFunction();
            if (row.quit_info && row.quit_info.quit_status == 0) {
                // 待离职
                this.$router.push({
                    name: "MLeaveOfficeDetail",
                    query: {
                        uid: row.user_id,
                        id: row.quit_info.id,
                    },
                });
            } else {
                this.$router.push({
                    name: "MPersonnelDetail",
                    query: {
                        uid: row.user_id,
                    },
                });
            }
        },
        handleClickDepNode(data) {},
        onSearch() {
            if(this.isShowDepartment) {
                this.getDepartmentList();
            } else {
                this.onPullRefreshList();
            }
        },
        //获取部门列表
        getDepartmentList() {
            this.loading = true;
            GetCompanyDepartmentList({ department_name: this.searchForm.keyword }).then((res) => {
                if (res.code === 200) {
                    this.total_users = res.data.total_users;
                    this.company_name = res.data.company_name;
                    this.departmentList = res.data.departments || [];
                    this.departmentInfo = null;
                    if (this.pullDownLoading) {
                        this.pullDownLoading = false;
                        this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                    }
                } else {
                    this.$toast({
                        message: res.message,
                        type: "fail",
                    });
                }
                this.loading = false;
            });
        },
        // 展示选中用户
        handleClickShowUser() {
            this.selectUserListVisible = true;
        },
        // 批量操作确认类型
        handleClickOperateType(type) {
            if (!this.selectedList.length) return this.$toast("请至少选择一条数据");
            this.setLocalStorageFunction();
            switch (type) {
                case "changeDepartment":
                    // 变更部门
                    const ids = this.selectedList.map((item) => item.user_id);
                    CheckUserAuthDepartment({user_ids: ids}).then(res=> {
                        if(res.code === 200) {
                            if (res.data.del) {
                                // 可更改
                                this.$router.push({
                                    name: "MPersonnelDepartmentChange",
                                    query: {
                                        user_ids: ids,
                                    },
                                });
                            } else {
                                // 不可更改
                                // 提示框
                                Dialog.confirm({
                                    title: "变更部门",
                                    message: res.data.msg,
                                    className: "my_dialog",
                                    confirmButtonColor: "rgba(41, 144, 255, 1)",
                                    confirmButtonText: "确定",
                                    showCancelButton: false
                                })
                                    .then(() => {
                                        this.$router.push({
                                            name: "MPersonnelDepartmentChange",
                                            query: {
                                                user_ids: ids,
                                            },
                                        });
                                    })
                                    .catch(() => {});
                            }
                        }
                    })
                    // localStorage.setItem("MPersonnelDepartmentChangeList", JSON.stringify(ids));
    
                    break;
                case "invit":
                    // 邀请完善信息
                    Dialog.confirm({
                        title: "邀请完善信息",
                        message: "邀请后将通知对应人员完善员工档案，可在【后台管理-设置字段】中设置。",
                        className: "my_dialog",
                        confirmButtonColor: "rgba(41, 144, 255, 1)",
                        confirmButtonText: "确定",
                    })
                        .then(() => {
                            this.selectedList = [];
                            this.isCheck = false;
                            this.$toast("已邀请");
                        })
                        .catch(() => {});
                    break;
            }
        },
        // 每一项的复选框改变
        handleClickChangeSelect(item) {
            if (item.checked) {
                this.selectedList.push(item);
            } else {
                const index = this.selectedList.findIndex((list) => list.id == item.id);
                this.selectedList.splice(index, 1);
            }
            if (this.selectedList.length < this.tableData.length) {
                this.isCheckAll = false;
            } else {
                this.isCheckAll = true;
            }
        },
        // 全选框改变
        handleClickCheckAll() {
            this.isCheckAll = !this.isCheckAll;
            this.tableData.forEach((item) => {
                this.$set(item, "checked", this.isCheckAll);
            });
        },
        // 已选用户数据复选框选中状态
        changeItemSelete(data) {
            if (data.type == "item") {
                // 取消单个选中
                const item = data.data;
                const list = this.tableData.find((list) => list.user_id === item.user_id);
                if (list) {
                    this.$set(list, "checked", false);
                }
            } else {
                // 取消全部的选择
                this.tableData.forEach((item) => {
                    this.$set(item, "checked", false);
                });
            }
        },
        onPullRefreshList() {
            this.loading = true;
            this.pagination.pageNum = 1;
            this.finishedList = false;
            this.tableData = [];
            this.getTableData();
        },
        onLoadList() {
            if(this.pagination.total == this.tableData.length){
                return false
            }
            if(this.loading == false){
                this.getTableData();
            }
        },
        getTableData() {
            this.loading = true;
            const params = {
                keyword: this.searchForm.keyword,
                department_id: this.searchForm.department_id,
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                custom_filter: this.custom_filter,
            };
            getUserListPage(params).then((res) => {
                if (res.code === 200) {
                    const { data, total } = res.data;
                    this.tableData = this.tableData.concat(data);
                    this.pagination.total = total;
                    this.pagination.pageNum++;
                    this.loading = false;
                    if (this.pullDownLoading) {
                        this.pullDownLoading = false;
                        this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                    }
                } else {
                    this.loading = false;
                    this.$toast({
                        message: res.message,
                        type: "fail",
                    });
                }
            });
        },
        getStaus(i) {
            let status = "";
            switch (i) {
                case 0:
                    status = "";
                    break;
                case 1:
                    status = "pendingEmployment";
                    break;
                case 2:
                    status = "pendingConfirm";
                    break;
                case 3:
                    status = "pendingLeave";
                    break;
                case 4:
                    status = "unRegist";
                    break;
            }
            return status;
        },
    },
};
</script>

<style lang="scss" scoped>
.top_search {
    padding: 6px 16px;
    background: rgba(255, 255, 255, 1);

    .van-search {
        padding: 0;
        border-radius: 6px;
        background-color: rgba(243, 243, 243, 1);
        overflow: hidden;

        .van-search__content {
            background-color: rgba(243, 243, 243, 1);

            ::v-deep {
                .van-icon-search {
                    color: rgba(51, 51, 51, 1);
                }
            }
        }
    }
}

.tree_content_title {
    display: flex;
    justify-content: space-between;
    padding: 11px 16px;
    background-color: rgba(255, 255, 255, 1);

    span {
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
    }

    .iconfont {
        font-size: 16px;
        color: rgba(153, 153, 153, 1);
    }
}

.radio_option_wrap {
    width: 100%;
    height: 100%;
    padding: 0 16px 35px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    .radio_option_list {
        max-height: calc(100% - 90px);
        overflow-y: auto;
        border-radius: 8px;

        .radio_option_item {
            background-color: #ffffff;
            text-align: center;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            padding: 10px 0;
            color: #666666;
            border-bottom: 1px solid #dedede;

            &:first-child {
                border-radius: 8px 8px 0 0;
            }

            &:last-child {
                border-bottom: none;
                border-radius: 0 0 8px 8px;
            }
        }
    }

    .cancel_btn {
        background-color: #ffffff;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        padding: 10px 0;
        color: #666666;
        border-radius: 8px;
        box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.08);
        margin-top: 10px;
    }
}

.mobile_container {
    .el-tree {
        ::v-deep {
            .el-tree-node {
                .el-tree-node__content {
                    height: 44px;
                    border-bottom: 1px solid rgba(247, 248, 250, 1);
                    background-color: #ffffff;
                }
            }

            .custom_tree_node {
                flex: 1;
                overflow: hidden;
                padding-right: 16px;
                display: flex;
                gap: 8px;

                .custom_tree_text {
                    flex: 1;
                    display: flex;
                    overflow: hidden;

                    span {
                        font-size: 14px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 22px;
                        color: rgba(51, 51, 51, 1);
                    }

                    span:nth-child(2) {
                        flex-shrink: 0;
                    }
                }

                .custom_tree_icon {
                    flex-shrink: 0;

                    .iconfont {
                        color: rgba(153, 153, 153, 1);
                        font-size: 14px;
                    }
                }
            }
        }
    }
    ul {
        li {
            padding: 0 16px;
            height: 68px;
            margin-bottom: 1px;
            background-color: rgba(255, 255, 255, 1);
            display: flex;
            align-items: center;
            gap: 8px;
            .img_box {
                width: 44px;
                height: 44px;
                border-radius: 50%;
                background-color: rgba(204, 204, 204, 1);
                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    object-fit: cover;
                }
            }
            .list_item_middle {
                flex: 1;
                overflow: hidden;
                p:nth-child(1) {
                    font-size: 14px;
                    font-weight: 700;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(51, 51, 51, 1);
                    margin-bottom: 2px;
                    display: flex;
                    align-items: center;
                    gap: 8px;
                }
                .tag_status {
                    flex-shrink: 0;
                    height: 18px;
                    padding: 0 4px;
                    border-radius: 5px;
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 18px;
                    &.tag_status_warning {
                        background-color: rgba(240, 170, 50, 0.15);
                        color: rgba(240, 170, 50, 1);
                    }
                    &.tag_status_success {
                        background-color: rgba(90, 179, 51, 0.15);
                        color: rgba(90, 179, 51, 1);
                    }
                    &.tag_status_danger {
                        background-color: rgba(228, 65, 68, 0.15);
                        color: rgba(228, 65, 68, 1);
                    }
                    &.tag_status_primary {
                        background-color: rgba(41, 144, 240, 0.15);
                        color: rgba(41, 144, 240, 1);
                    }
                    &.tag_status_warning2 {
                        background-color: rgba(255, 141, 26, 0.15);
                        color: rgba(255, 141, 26, 1);
                    }
                }
                p:nth-child(2) {
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(102, 102, 102, 1);
                }
            }
            .list_item_right {
                height: 100%;
                padding-left: 16px;
                display: flex;
                align-items: center;

                ::v-deep {
                    .van-checkbox__icon {
                        font-size: 16px;

                        .van-icon {
                            border-color: rgba(217, 217, 217, 1);
                            border-radius: 4px;
                            background-color: rgba(255, 255, 255, 1);
                        }
                    }

                    .van-checkbox__icon--checked {
                        .van-icon {
                            border-color: rgba(41, 144, 255, 1);
                            background-color: rgba(41, 144, 255, 1);
                        }
                    }
                }
            }
        }
    }
}
.my_delete_dialog {
    ::v-deep {
        .van-dialog__content {
            padding: 24px 0 !important;
            .title {
                font-size: 16px;
                font-weight: 700;
            }
            p {
                padding: 0 16px;
                text-align: center;
                & + p {
                    margin-top: 16px;
                }
            }
        }
    }
}
.batch_select_icon {
    position: absolute;
    bottom: 107px;
    right: 16px;
    width: 30px;
    height: 30px;
    background: rgba(75, 162, 255, 1);
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .iconfont {
        font-size: 20px;
        color: #ffffff;
    }

    span {
        position: absolute;
        top: -1px;
        right: 0;
        padding: 0 3px;
        font-size: 8px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 12px;
        color: rgba(255, 255, 255, 1);
        background: rgba(228, 65, 68, 1);
        border-radius: 50%;
    }
}
</style>
<style lang="scss">
.top_operator_list {
    width: 104px;
    padding: 4px 0;

    li {
        list-style: none;
        width: 100%;
        height: 38px;
        line-height: 38px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;

        span {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            color: rgba(51, 51, 51, 1);
        }

        &:active {
            background-color: rgba(153, 153, 153, 0.04);
        }
    }
}
</style>
